import React from "react";
import "./CardTwoScreen.css";

export default function CardTwoScreen() {
  return (
    <div className="card-two-screen">
      <h1 className="card-two-title">Գիտե՞ք, որ կարող եք կապիտալ ստեղծել Ձեր աշխատավարձից։</h1>
      <p className="card-two-description">
        Մեզնից շատերը կարծում են թե <span className="highlight highlight-orange">անհնար է կապիտալ ստեղծել</span> երբ ապրում ենք աշխատավարձից աշխատավարձ։
      </p>
      <p className="card-two-description">
        Թույլ տվեք Ձեզ <span className="highlight highlight-red">փոքր մարտահրավեր</span> նետել․ Դուք կարող եք փոխել փողի հանդեպ Ձեր վերաբերմունքն ու ստեղծել փոքր սովորություններ, որոնք արտասովոր փոփոխությունների կտանեն։
      </p>
    </div>
  );
}
